module.exports = __webpack_public_path__ + "img/weixin.f3c06dd1.jpg";